import { Bildungsangebot } from '../model';
import { Weiterbildungsart } from '../model/weiterbildungsarten';
import { testTermin } from './termin.data';

export const testAngebot: Bildungsangebot = {
  id: 5,
  titel: 'titel',
  inhalt: 'inhalt',
  anzahlTermine: 1,
  bildungsanbieter: {
    id: 123,
    name: 'name',
    telefonVorwahl: 'telefonVorwahl',
    telefon: 'telefonDurchwahl',
    mobilVorwahl: 'mobilVorwahl',
    mobil: 'mobilDurchwahl',
    faxVorwahl: 'faxVorwahl',
    faxDurchwahl: 'faxDurchwahl',
    homepage: 'homepage',
    email: 'mail',
    adresse: {
      id: 987,
      bezeichnung: 'bezeichnung',
      strasse: 'strasse',
      hinweise: '',
      ort: 'Wintersdorf',
      plz: '04610',
      barrierefrei: false
    },
    logo: 'url'
  },
  termine: [...[testTermin]],
  systematiken: [
    {
      dkzid: 70336,
      codeNr: 'C 134-13-b2',
      kurzbezeichnung: 'MCSE-Zertifizierung - Microsoft Certified Systems Engineer'
    }
  ],
  weiterbildungsart: Weiterbildungsart.BERUFLICHE_QUALIFIZIERUNG
};
